export default "__VITE_ASSET__C9Kr1SxO__"